// eslint-disable-next-line no-restricted-globals
const _global =
  (typeof window !== 'undefined' && window) ||
  (typeof global !== 'undefined' && global) ||
  {};

// @ts-ignore
(_global).process = (_global).process || { env: {} };

// eslint-disable-next-line import/no-extraneous-dependencies
// @ts-ignore - path alias provided via craco
const ReactDOMReal = require('react-dom-actual');

// Inject a minimal stub for legacy code that still calls ReactDOM.findDOMNode.
// @ts-ignore
if (!ReactDOMReal.findDOMNode) {
  let warned = false;
  // @ts-ignore
  ReactDOMReal.findDOMNode = function findDOMNode() {
    if (process.env.NODE_ENV !== 'production' && !warned) {
      // eslint-disable-next-line no-console
      console.warn(
        'Legacy code called findDOMNode(). It was removed from react-dom in React 19. ' +
          'A no-op shim is being used. Please upgrade the offending dependency.'
      );
      warned = true;
    }
    return null;
  };
}

module.exports = ReactDOMReal;